import { PitchViz } from '@statsbomb/kitbag-datavis';
import { useAtomValue } from 'jotai';
import { PitchOrientation, UnwrappedPitchEventsAtom } from '@/types/visualisation';
import { PitchVisWithAttackingDirectionArrow } from '../PitchVisualisation/PitchVisWithAttackingDirectionArrow';
import { EventMapLayers } from './EventMapLayers';

export const EventMapPreview = ({
  unwrappedPitchEventsAtom,
  currentlySelectedVideoId,
}: {
  unwrappedPitchEventsAtom: UnwrappedPitchEventsAtom;
  currentlySelectedVideoId: string | null;
}) => {
  const { markerEvents, arrowEvents } = useAtomValue(unwrappedPitchEventsAtom);
  const eventMapLayers = (
    <EventMapLayers
      currentlySelectedVideoId={currentlySelectedVideoId}
      markerEvents={[...markerEvents, ...arrowEvents]}
      arrowEvents={[]}
      useDefaultColor
    />
  );
  const rotationName: PitchOrientation = 'HORIZONTAL';

  return (
    <PitchVisWithAttackingDirectionArrow pitchVisType="eventmap" pitchRotation={rotationName}>
      <PitchViz
        data-testid="event-map-preview"
        /* this is intentionally empty to overwrite pitch viz svg styles
      to position the arrow correctly */
        className=""
        rotationName={rotationName}
        pitchFocusZoneName="FULL_PITCH"
        overlay={eventMapLayers}
      />
    </PitchVisWithAttackingDirectionArrow>
  );
};
